<template>
  <div class="container">
    <sys-loading :loading="loading" />
    <div v-if="isMobile" class="mobileRoot">
      <div class="mobileMain">
        <img class="logo" src="../assets/new-sport/logo.png" alt="logo">
        <div class="mobile-form-panel">
          <img class="form-img" src="../assets/new-sport/h5-title.webp" alt="h5-title">
          <div class="form-title">Đăng ký tài khoản</div>
          <div class="form-subTitle">
            Vui lòng lưu ý thành viên không được phép sở hữu hơn một tài khoản.
            <div style="display: flex; align-items: center;">
              <div>
                <span>Đã có tài khoản?</span>
                <span>Đăng nhập tại đây!</span>
              </div>
              <div class="subTitle-right">Chơi thử</div>
            </div>
          </div>
          <div class="h5-form-content">
            <div class="h5-tao">
              <el-form :model="form" ref="form" label-position="left">
                <el-form-item prop="userName" label="Tên đăng nhập" :rules="userNameRule">
                  <el-input
                    v-model="form.userName"
                    placeholder="Nhập tên đăng nhập"
                    maxlength="20"
                    oninput="value=value.replace(/\W/, '')"
                    autocomplete="off"
                  />
                </el-form-item>
                <el-form-item prop="password" label="Mật khẩu đăng nhập" :rules="passwordRule">
                  <div class="input-group">
                    <el-input
                      :type="showPwd ? 'text' : 'password'"
                      v-model="form.password"
                      placeholder="Nhập mật khẩu"
                      autocomplete="off"
                      maxlength="15"
                    />
                    <img class="eyes" @click="showPwd=!showPwd"
                         :src="showPwd ? require('../assets/new-sport/eyes-open.png') : require('../assets/new-sport/eyes-close.png')" alt="open">
                  </div>
                </el-form-item>
                <el-form-item prop="checkPass" label="Xác nhận mật khẩu" :rules="passwordRule2">
                  <div class="input-group">
                    <el-input
                      :type="showConfirmPwd ? 'text' : 'password'"
                      v-model="form.checkPass"
                      placeholder="Xác nhận mật khẩu"
                      autocomplete="off"
                      maxlength="15"
                    />
                    <img class="eyes" @click="showConfirmPwd=!showConfirmPwd"
                         :src="showConfirmPwd ? require('../assets/new-sport/eyes-open.png') : require('../assets/new-sport/eyes-close.png')" alt="open">
                  </div>

                </el-form-item>
                <el-form-item
                  prop="phonenumber"
                  :rules="phoneRule"
                  label="Số điện thoại"
                >
                  <el-input
                    v-model="form.phonenumber"
                    placeholder="Nhập số điện thoại của bạn"
                    maxlength="10"
                    oninput="value=value.replace(/\D/, '')"
                    autocomplete="off"
                  />
                </el-form-item>
                <el-form-item prop="verificationCode" label="Mã xác nhận" :rules="codeRule">
                  <div class="input-group">
                    <el-input
                      v-model="form.verificationCode"
                      placeholder="Nhập mã xác minh"
                      maxlength="4"
                      autocomplete="off"
                    />
                    <div class="code-area">
                      <img v-show="!!codeImg" class="vircode" :src="codeImg" alt="code"/>
                      <img class="refresh" src="../assets/new-sport/refresh.png" @click="getCode" alt="refresh">
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="Mã giới thiệu">
                  <el-input
                    v-model="form.inviteCode"
                    placeholder="Nhập mã giới thiệu (không bắt buộc)"
                  />
                </el-form-item>
              </el-form>
              <v-captcha
                ref="vcaptcha1"
                :dialogVisible="dialogVisible"
                :showCheck="showCheck"
                @cb="handleConfirm"
                :nativeButton="{
                    width: '3rem',
                    height: '0.65rem'
                  }"
              >
                <img class="btn-gif"
                     @click="submitAction"
                     src="../assets/new-sport/btn-register.webp"
                     alt="reg"
                />
              </v-captcha>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="content">
      <div class="mask">
        <div class="form-panel">
          <div class="leftArea"/>
          <div class="rightArea">
            <div class="rightTitle">
              Đăng ký tài khoản
            </div>
            <div class="subTitle">
              Vui lòng lưu ý thành viên không được phép sở hữu hơn một tài khoản.
            </div>
            <div class="regTitle">
              <span>Đã có tài khoản?</span>
              <span>Đăng nhập tại đây!</span>
              <span>Chơi thử</span>
            </div>
            <div class="form-content">
              <div class="inputs">
                <div class="tao">
                  <el-form :model="form" ref="form" label-position="left">
                    <el-form-item prop="userName" label="Tên đăng nhập" :rules="userNameRule">
                      <el-input
                        v-model="form.userName"
                        placeholder="Nhập tên đăng nhập"
                        maxlength="20"
                        oninput="value=value.replace(/\W/, '')"
                        autocomplete="off"
                      />
                    </el-form-item>
                    <el-form-item prop="password" label="Mật khẩu đăng nhập" :rules="passwordRule">
                      <div class="input-group">
                        <el-input
                          :type="showPwd ? 'text' : 'password'"
                          v-model="form.password"
                          placeholder="Nhập mật khẩu"
                          autocomplete="off"
                          maxlength="15"
                        />
                        <img class="eyes" @click="showPwd=!showPwd"
                             :src="showPwd ? require('../assets/new-sport/eyes-open.png') : require('../assets/new-sport/eyes-close.png')" alt="open">
                      </div>
                    </el-form-item>
                    <el-form-item prop="checkPass" label="Xác nhận mật khẩu" :rules="passwordRule2">
                      <div class="input-group">
                        <el-input
                          :type="showConfirmPwd ? 'text' : 'password'"
                          v-model="form.checkPass"
                          placeholder="Xác nhận mật khẩu"
                          autocomplete="off"
                          maxlength="15"
                        />
                        <img class="eyes" @click="showConfirmPwd=!showConfirmPwd"
                             :src="showConfirmPwd ? require('../assets/new-sport/eyes-open.png') : require('../assets/new-sport/eyes-close.png')" alt="open">
                      </div>

                    </el-form-item>
                    <el-form-item
                      prop="phonenumber"
                      :rules="phoneRule"
                      label="Số điện thoại"
                    >
                      <el-input
                        v-model="form.phonenumber"
                        placeholder="Nhập số điện thoại của bạn"
                        maxlength="10"
                        oninput="value=value.replace(/\D/, '')"
                        autocomplete="off"
                      />
                    </el-form-item>
                    <el-form-item prop="verificationCode" label="Mã xác nhận" :rules="codeRule">
                      <div class="input-group">
                        <el-input
                          v-model="form.verificationCode"
                          placeholder="Nhập mã xác minh"
                          maxlength="4"
                          autocomplete="off"
                        />
                        <div class="code-area">
                          <img v-show="!!codeImg" class="vircode" :src="codeImg" alt="code"/>
                          <img src="../assets/new-sport/refresh.png" @click="getCode" alt="refresh">
                        </div>
                      </div>
                    </el-form-item>

                    <el-form-item label="Mã giới thiệu">
                      <el-input
                        v-model="form.inviteCode"
                        placeholder="Nhập mã giới thiệu (không bắt buộc)"
                      />
                    </el-form-item>
                  </el-form>
                  <v-captcha
                    ref="vcaptcha1"
                    :dialogVisible="dialogVisible"
                    :showCheck="showCheck"
                    @cb="handleConfirm"
                    :vstyle="{ position: 'absolute', bottom: '-70px' }"
                    :nativeButton="{
                    width: '220px',
                    height: '55px'
                  }"
                  >
                    <img class="btn-gif"
                         @click="submitAction"
                         src="../assets/new-sport/btn-register.webp"
                         alt="reg"
                    />
                  </v-captcha>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <sys-alert :is-mobile="isMobile" :visible="showAlert" :error-msg="alertMsg" :error-type="errorType" @close="alertClose"/>
  </div>
</template>

<script>
import md5 from "js-md5";
import '../../static/js/initRem'
import {
  FORM_VALID_MESSAGE,
  DOMAIN_INVITE_CODE
} from "../utils/constant";
import {userRegister, getCapCode, createCustomer} from "../utils/request";
import {
  encodePlatformUrl,
  isMobile,
  validatePhone,
  replacePhonePrefix, validatePass, validateCode
} from "../utils/tools";
import { captcha } from "@/mixins/captcha";
import SysAlert from "./common/SysAlert.vue";

export default {
  name: "QH88",
  mixins: [captcha],
  components: {SysAlert},
  data() {
    const validateUserName = (rule, value, callback) => {
      if(!value) {
        callback(new Error(FORM_VALID_MESSAGE.emptyMsg))
      }
      callback()
    };
    const validatePass2 = (rule, value, callback) => {
      if (!/^(?:(?!^[0-9]+$)(?!^[A-Za-z]+$))[0-9A-Za-z~!@#$%^(&*).,?/{}]{6,15}$/.test(value)) {
        callback(new Error('6 - 15 ký tự bao gồm chữ và số '));
      } else if (value !== this.form.password) {
        callback(new Error('Xác nhận mật khẩu không trùng khớp '));
      } else {
        callback();
      }
    };
    return {
      showPwd: false,
      showConfirmPwd: false,

      showAlert: false,
      alertMsg: "Mật khẩu không khớp",
      errorType: "failed",

      isMobile: isMobile(),
      dialogVisible: false,
      loading: false,
      dialogBgi: require("../assets/sport/bgi-dialog.png"),
      movingEvent: 0,
      codeImg:"",
      form: {
        by: 1,
        userName: "",
        password: "",
        checkPass:"",
        phonenumber: "",
        link: window.location.host,
        domain: "",
        inviteCode: null
      },
      userNameRule: [
        {validator: validateUserName, trigger: "blur"},
        {
          min: 4,
          max: 20,
          trigger: "blur",
          message: FORM_VALID_MESSAGE.usernameFormatErr
        }
      ],
      passwordRule: [
        { validator: validatePass, trigger: "blur" }
      ],
      passwordRule2: [
        { validator: validatePass2, trigger: "blur"}
      ],
      phoneRule: [
        { validator: validatePhone, trigger: 'blur' },
      ],
      codeRule: [
        { validator: validateCode, trigger: "blur" }
      ],
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getCode()
  },
  methods: {
    getCode() {
      getCapCode().then(res=>{
        if (!res.body.code){
          this.codeImg = res.body.data
        }
      })
        .catch(err=>{
          console.log(err)
        })
    },
    submitAction() {
      let _this = this;
      this.$refs.form.validate(valid => {
        if (valid) {
          _this.loading = true;
          const inviteCode = DOMAIN_INVITE_CODE[location.host] || "";
          _this.form.inviteCode = inviteCode;
          _this.form.domain = location.host;
          _this.form.userName = this.form.userName;
          _this.register();
        }
      });
    },
    register() {
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm() {
      let params = Object.assign({}, this.form, {checkPass: ''});
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      params.phone = replacePhonePrefix(params.phonenumber);
      Reflect.deleteProperty(params, 'checkPass');
      Reflect.deleteProperty(params, 'phonenumber');
      userRegister(params, this.captchaParams)
        .then(res => {
          this.showAlert = true;
          if (res.data.code == 0) {
            this.errorType = "success";
            this.alertMsg = "Đăng ký thành công";
            // createCustomer(this.form);
            setTimeout(() => {
              const directUrl = encodePlatformUrl(
                'https://m8mfg8be.cc',
                this.form.userName,
                isMobile() ? params.password : this.form.password,
                res.data.data.token
              );
              window.location.href = directUrl;
            }, 5000);
          } else {
            if([16,188].includes(res.data.code)) {
              this.errorType = "warning"
            } else {
              this.errorType = "failed";
            }
            this.alertMsg = res.data.msg;
            this.handleOpen(res.data.code, this.getCode());
          }
          this.loading = false;
        })
        .catch(error => {
          this.showAlert = true;
          this.errorType = "failed";
          this.alertMsg = error.data || "Error!";
          this.loading = false;
        });
    },
    alertClose() {
      this.showAlert=false
      this.alertMsg=""
    }
  }
};
</script>

<style lang="less" scoped>

::-webkit-input-placeholder {
  color: #ffffff;
}

// 通用文件
.content,
.mobileRoot {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}
// pc 端
.content {
  width: 100%;
  height: 100vh;
  background-image: url("../assets/new-sport/bgi-pc.webp");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  .mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding-top: 80px;
    background: rgba(0, 0, 0, 0.75);

    .form-panel {
      width: 1100px;
      height: 765px;
      background-image: url("../assets/new-sport/bgi-gorm.webp");
      background-size: 100% 100%;
      position: relative;
      padding: 40px;
      box-sizing: border-box;

      display: flex;
      .leftArea {
        width: 472px;
        height: 684px;
        background-image: url("../assets/new-sport/left-pic.webp");
        background-size: 100% 100%;
      }
      .rightArea {
        width: 540px;
        display: flex;
        align-items: center;
        flex-direction: column;
        .rightTitle {
          font-weight: 700;
          font-size: 35px;
          line-height: 1.5;
          letter-spacing: 2px;
          background: linear-gradient(0deg, #BC9F51 0%, #FFE492 40%, #FFE492 60%, #FFE492 80%, #A9914A 100%);
          /* 2. 将背景裁剪到文字 (注意需要加上 -webkit- 前缀) */
          -webkit-background-clip: text;
          background-clip: text;

          /* 3. 将文字颜色设为透明，让背景显示出来 */
          color: transparent;

          /* 4. 为了保险，可以设为 inline-block，确保背景范围正确 */
          display: inline-block;
        }
        .subTitle {
          font-weight: 400;
          font-size: 17px;
          line-height: 1.2;
          color: white;
          white-space: nowrap;
          margin-bottom: 10px;
          align-self: flex-end;
        }
        .regTitle {
          display: flex;
          width: 100%;
          font-weight: 400;
          font-size: 18px;
          line-height: 1;
          color: white;
          span:last-child {
            font-size: 16px;
            margin-left: auto;
            color: #FFFFC1;
          }
        }
      }


      .form-content {
        width: 540px;
        height: 556px;
        border-radius: 20px;
        border: 1px solid #FFDB5F;
        background: linear-gradient(135deg, #121029 0%, #110F28 100%);

        .inputs {
          width: 100%;
          height: 100%;

          .tao {
            padding: 28px 14.5px;
            height: 70%;
            margin: 5px auto 0;
            display: flex;
            flex-flow: column;
            align-items: center;
            position: relative;
          }

          /deep/ .el-form {
            width: 100%;

            .el-form-item {
              display: flex;
              align-items: center;
              width: 100%;
              margin-bottom: 25px;
            }
            .el-form-item__content {
              display: flex;
              flex: 1;
            }

            .el-form-item__label {
              width: 219px;
              font-weight: 700;
              font-size: 18px;
              line-height: 1.2;
              color: white;
            }

            ::-webkit-input-placeholder {
              color: #A9A9A9 !important;
            }

            .el-input .el-input__inner {
              border: 1px solid #FFDB5F;
              width: 284px;
              height: 44px;
              border-radius: 10px;
              background: transparent;
              color: #fff;
              outline: none;
              text-decoration: none;
            }
          }

          .input-group {
            position: relative;
            .eyes {
              width: 16px;
              height: 16px;
              cursor: pointer;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 10px;
              z-index: 99;
            }
            .code-area {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 10px;
              display: flex;
              align-items: center;
              column-gap: 5px;
              .vircode {
                width: 80px;
                height: 28px;
              }
            }
          }

          .btn-gif {
            width: 170px;
            height: 45px;
            cursor: pointer;
            margin-top: 24px;
          }
        }

        .success-show {
          width: 85%;
          height: 70%;
          margin: 5px auto 0;
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;

          p {
            width: 80%;
            text-align: center;
          }
        }

        p.error-msg {
          width: 100%;
          margin: 0;
          text-align: center;
        }
      }
    }
  }
}

// 手机端
.mobileRoot {
  //height: 100%;
  background: url("../assets/new-sport/h5-bg.webp") no-repeat center / 100% 100%;
  padding: 0.36rem 0.26rem;

  .mobileMain {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    position: relative;
    row-gap: 0.2rem;

    .logo {
      width: 2.55rem;
      height: 1.03rem;
    }

    .mobile-form-panel{
      min-height: 10.33rem;
      background: url("../assets/new-sport/h5-bgi-gorm.webp") no-repeat center / 100% 100%;
      padding: 0.26rem 0.15rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;

      .form-img {
        width: 6.32rem;
        height: 2.2rem;
        object-fit: contain;
      }

      .form-title {
        font-weight: 700;
        font-size: 0.48rem;
        line-height: 1.2;
        letter-spacing: 0.02rem;
        background: linear-gradient(0deg, #BC9F51 0%, #FFE492 40%, #FFE492 60%, #FFE492 80%, #A9914A 100%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        display: inline-block;
      }
      .form-subTitle {
        white-space: nowrap;
        font-weight: 400;
        font-size: 0.21rem;
        line-height: 1.5;
        color: white;
        height: 0.9rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .subTitle-right {
          margin-left: auto;
          color: #FFFFC1;
        }
      }

      .h5-form-content {
        width: 6.23rem;
        min-height: 6.15rem;
        border-radius: 0.2rem;
        padding: 0.2rem;
        background: linear-gradient(135deg, #121029 0%, #110F28 100%);
        border: 0.01rem solid #FFDB5F;

        .h5-tao {
          /deep/ .el-form {
            width: 100%;

            .el-form-item {
              display: flex;
              align-items: center;
              width: 100%;
              margin-bottom: 0.25rem;
            }
            .el-form-item__content {
              display: flex;
              flex: 1;
            }

            .el-form-item__label {
              width: 2.8rem;
              font-weight: 700;
              font-size: 0.24rem;
              line-height: 1.5;
              color: white;
              white-space: nowrap;
            }

            ::-webkit-input-placeholder {
              font-size: 0.24rem;
              color: #A9A9A9 !important;
            }

            .el-input .el-input__inner {
              border: 0.01rem solid #FFDB5F;
              width: 3.4rem;
              height: 0.6rem;
              border-radius: 0.1rem;
              background: transparent;
              color: #fff;
              outline: none;
              text-decoration: none;
            }
            .el-form-item__error {
              font-size: 0.18rem;
            }
          }

          .input-group {
            position: relative;
            .eyes {
              width: 0.25rem;
              height: 0.25rem;
              cursor: pointer;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 0.15rem;
              z-index: 99;
            }
            .code-area {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 0.1rem;
              display: flex;
              align-items: center;
              column-gap: 5px;
              .vircode {
                width: 0.8rem;
                height: 0.4rem;
              }
              .refresh {
                width: 0.25rem;
                height: 0.25rem;
              }
            }
          }

          .btn-gif {
            width: 2.3rem;
            height: 0.65rem;
            cursor: pointer;
            margin-top: 0.24rem;
          }
        }

      }

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/QH88.vue